import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import OperationProductCard from 'components/shared/operation/OperationProductCard/OperationProductCard';

const MovementProductPanel = ({ product }) => {
  if (product) {
    return (
      <OperationProductCard product={product}>
        {product.code ? (
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 500,
              color: 'text.secondary',
            }}
          >
            {product.code}
          </Typography>
        ) : null}
      </OperationProductCard>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        backgroundColor: '#fff',
        borderRadius: '12px',
        border: '1px dashed',
        borderColor: 'divider',
        p: 4,
        minHeight: 160,
        width: '100%',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme =>
            alpha(theme.palette.brand.grey.quaternary, 0.45),
        }}
      >
        <Inventory2OutlinedIcon
          sx={{ fontSize: 28, color: 'brand.grey.ternary' }}
        />
      </Box>
      <Typography sx={{ color: 'brand.grey.ternary', fontSize: 14 }}>
        محصولی برای جابه جایی ثبت نشده است.
      </Typography>
    </Box>
  );
};

export default MovementProductPanel;
